import OfferImageOne from "../assets/special-offers/offer-image-1.png";
import OfferImageTwo from "../assets/special-offers/offer-image-2.png";
import OfferImageThree from "../assets/special-offers/offer-image-3.png";
import OfferImageFour from "../assets/special-offers/offer-image-4.png";
import OfferImageFive from "../assets/special-offers/offer-image-5.png";
import OfferImageSix from "../assets/special-offers/offer-image-6.png";
import OfferImageSeven from "../assets/special-offers/offer-image-7.png";


const offersList = [
    {
      image: OfferImageOne,
      title: "Cosmetic Consultation / Orthodontics & Clear Aligners",
      price: "$59",
      description: [
        "Examination: A personalized assessment to evaluate your smile goals, dental alignment, and suitability for cosmetic treatments or clear aligners like Invisalign.",
        "Treatment Planning: Includes, discussion of expected outcomes, and a customized plan outlining options, duration, and costs."
      ]
    },
    {
      image: OfferImageTwo,
      title: "New Patient Dental Checkup, Clean, Fluoride & X-Rays",
      price: "$205",
      description: [
        "Comprehensive Oral Check-Up: A thorough examination including x rays and photos if needed to assess teeth, gums, and mouth to detect early signs of decay, gum disease, or other dental issues.",
        "Professional Clean: Removal of plaque, tartar, and stains followed by polishing to maintain oral hygiene and prevent future dental problems."
      ]
    },
    {
      image: OfferImageThree,
      title: "Emergency & Up to Two X-Rays",
      price: "$98",
      description: [
        "Gum Infection & Toothache: Assessment of pain or swelling caused by infections, decay, or gum disease. Maximum of 2 x rays included.",
      ]
    },
    {
      image: OfferImageFour,
      title: "Dental Fillings",
      price: "$220",
      description: [
        "Tooth Decay Treatment: Dental fillings up to 2 surfaces to  restore teeth damaged by cavities, preventing further decay and restoring normal function.", 
        "Natural-Looking Materials: Options like composite resin blend with your tooth color for a seamless and durable finish."
      ]
    },
    {
      image: OfferImageTwo,
      title: "Gap Free New Patient Check Up and Clean",
      description: [
        "Comprehensive Oral Check-Up: A thorough examination including x rays and photos if needed to assess teeth, gums, and mouth to detect early signs of decay, gum disease, or other dental issues.",
        "Professional Clean: Removal of plaque, tartar, and stains followed by polishing to maintain oral hygiene and prevent future dental problems."
      ]
    },
    {
      image: OfferImageFive,
      title: "Teeth Whitening",
      price: "Starting from $450",
      description: [
        "Brighter, Whiter Smile: Professional teeth whitening removes stains and discoloration, enhancing the overall appearance of your smile.",
        "Safe & Effective: Customized treatments deliver noticeable results with minimal sensitivity, overseen by dental professionals for safety."
      ]
    },
    {
      image: OfferImageSix,
      title: "Grinding/Bruxism Mouthguard",
      price: "$730",
      description: [
        "Nighttime Protection: A custom-made mouthguard cushions your teeth and jaw to prevent damage caused by teeth grinding or clenching during sleep (bruxism).", 
        "Relieves Jaw Pain & Headaches: Helps reduce symptoms like jaw tension, facial pain, and morning headaches associated with bruxism."
      ]
    },
    {
      image: OfferImageSeven,
      title: "Dental Crown",
      price: "$1799",
      description: [
        "Tooth Restoration & Protection: A dental crown covers and strengthens a damaged or weakened tooth, restoring its shape, size, and function.",
        "Durable & Natural-Looking: Made from materials like porcelain or ceramic, crowns blend with your natural teeth and provide long-lasting results."
      ]
    }
];
  
export default offersList;
  